module.exports = __webpack_public_path__ + "static/media/logo_02.c11559ce.jpg";